import type { PrincipalRef, TimestampLike } from './common';

export const AI_PROVIDER_IDS = ['openai', 'anthropic', 'google', 'azure', 'openrouter', 'custom'] as const;
export type AiProviderId = (typeof AI_PROVIDER_IDS)[number];
/** Wire format an adapter speaks; several providers share one. */
export type AiProtocol = 'openai' | 'anthropic' | 'google';
export const AI_EFFORTS = ['none', 'low', 'medium', 'high'] as const;
export type AiEffort = (typeof AI_EFFORTS)[number];

export interface AiGenParams { effort: AiEffort; temperature: number; maxTokens: number; topP: number }
export interface AiModelInfo { id: string; label: string; contextWindow: number | null; source: 'provider' | 'manual' }
export interface AiProviderTest { ok: boolean; at: TimestampLike; model: string; latencyMs: number; message: string }
export interface AiProviderConfig {
  enabled: boolean;
  baseUrl: string;
  keyConfigured: boolean;
  keyHint: string;
  keyUpdatedAt: TimestampLike | null;
  keyUpdatedBy: PrincipalRef | null;
  defaultModel: string;
  defaults: AiGenParams;
  models: AiModelInfo[];
  modelsRefreshedAt: TimestampLike | null;
  lastTest: AiProviderTest | null;
}
export interface AiProvidersSettings { id: string; providers: Record<AiProviderId, AiProviderConfig> }

export interface AiPrice { inputPerMTok: number; outputPerMTok: number; source: 'seed' | 'provider' | 'manual'; updatedAt: TimestampLike | null }
export interface AiPricingSettings { id: string; models: Record<string, AiPrice> }

export interface AiProviderUsage { tokensIn: number; tokensOut: number; cost: number; runs: number }
/** aiUsage/{YYYY-MM}: monthly roll-up per provider, written only by Cloud Functions. */
export interface AiUsageMonth { id: string; providers: Partial<Record<AiProviderId, AiProviderUsage>> }
